// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import React from "react";
import TextFieldRtl from "../TextFieldRtl/TextFieldRtl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

const StyledTextField = TextFieldRtl();

const AutoCompleteMU = (props) => {
  const {
    title,
    setFieldValue,
    keyword,
    setKeyword,
    query,
    queryName,
    field,
    value,
    fieldSelect,
    fieldName,
    fieldNameShow,
  } = props;
  const [open, setOpen] = React.useState(false);

  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(open && options.length === 0);

  let timeOutVar;
  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    if (!keyword) {
      return undefined;
    }

    (async () => {
      const response = await query;
      const items = await response.data[queryName].data;

      if (active && items) {
        setLoading(false);
        setOptions(
          items.map((item) => {
            return item;
          }),
        );
      }
    })();

    return () => {
      active = false;
    };
  }, [loading, keyword]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
      // setKeyword('')
    }
  }, [open]);

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={open}
      onOpen={() => {
        setOpen(true);
        // setLoading(true);

        if (keyword !== value) {
          // setKeyword('')
        }
      }}
      onClose={() => {
        setOpen(false);
        setLoading(false);
      }}
      getOptionSelected={(option, value) => {
        return option[fieldSelect] === value[fieldSelect];
      }}
      onChange={(event, newValue) => {
        let fieldShow = "x";

        if (newValue) {
          if (Array.isArray(field)) {
            let name = "";

            let x = field.map(function (en) {
              return newValue[en];
            });

            fieldShow = x.join("-");
          } else {
            fieldShow = newValue[field];
          }

          setFieldValue(fieldNameShow, fieldShow);
          setFieldValue(fieldName, newValue[fieldSelect]);
          setKeyword(newValue[field]);
        } else {
          setFieldValue(fieldName, "");
          setFieldValue(fieldNameShow, "");
        }
      }}
      getOptionLabel={(option) => {
        if (Array.isArray(field)) {
          let name = "";

          let x = field.map(function (en) {
            return option[en];
          });

          return x.join(" - ");
        } else {
          return option[field];
        }
      }}
      options={options}
      loading={loading}
      loadingText={"منتظر باشید..."}
      noOptionsText={"موردی پیدا نشد"}
      filterOptions={(filter, state) => {
        return filter;
      }}
      inputValue={open ? keyword : value}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          onChange={(e) => {
            setKeyword(e.target.value);
            setLoading(true);
          }}
          error={props.touched && Boolean(props.errors)}
          helperText={props.touched && props.errors}
          label={title}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading && keyword !== "" ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default AutoCompleteMU;
